import React, { type FC, memo, use } from "react";
import { Button } from "@heroui/react";
import { Sparkles } from "@gravity-ui/icons";

import { AgentRunContext } from "./AgentRunProvider";
import { UserContext } from "@domain/context/UserProvider";
import { useTranslation } from "@domain/intl/useTranslation";
import { HoverGlow } from "@ui-components/HoverGlow";
import { ProductColors } from "@ui-components/ProductColors";

const BinaleAgentButtonImpl: FC = () => {
    const { t } = useTranslation();
    const { isAdminWrite } = use(UserContext);
    const { open } = use(AgentRunContext);

    if (!isAdminWrite) {
        return null;
    }

    return (
        <HoverGlow sparkle brightIcon>
            <Button
                variant="primary"
                className={`relative z-2 text-sm ${ProductColors.AIGradient.className}`}
                onPress={open}
            >
                <Sparkles className="size-4" />
                {t("app.agent.button")}
            </Button>
        </HoverGlow>
    );
};

export const BinaleAgentButton = memo(BinaleAgentButtonImpl);
